import React from 'react';
import { Grid } from '@mui/material';

const StarRatingSubHeader = ({ value, onChange, isReadOnly, fontSize }) => (
  <Grid className="subHeader" pb="14px">
    <input
      placeholder="یک عنوان فرعی وارد کنید"
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: fontSize,
        fontWeight: 500,
        lineHeight: 1.6,
        color: '#57647e',
      }}
      readOnly={isReadOnly}
      value={value}
      onChange={onChange}
    />
  </Grid>
);

export default StarRatingSubHeader;
